/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * Service for power control operations via the Flask API.
 */
angular.module('nsadmin').factory('powerControlService', ['$injector',
    function powerControlService($injector) {

        var flaskApiService = $injector.get('flaskApiService');

        var service = {};

        /**
         * Powers on/off a pod device.
         *
         * @param {String} podId
         *     The ID of the pod.
         *
         * @param {String} deviceSlot
         *     The device slot identifier.
         *
         * @param {Number} state
         *     Power state: 1 = on, 2 = off.
         *
         * @returns {Promise}
         *     A promise that resolves when the power command is executed.
         */
        service.powerPodDevice = function powerPodDevice(podId, deviceSlot, state) {
            return flaskApiService.post('/power/pod-device', {
                pod_id: podId,
                device_slot: deviceSlot,
                state: state
            });
        };

        /**
         * Powers on/off a shared device.
         *
         * @param {String} deviceSlot
         *     The device slot identifier.
         *
         * @param {Number} state
         *     Power state: 1 = on, 2 = off.
         *
         * @returns {Promise}
         *     A promise that resolves when the power command is executed.
         */
        service.powerSharedDevice = function powerSharedDevice(deviceSlot, state) {
            return flaskApiService.post('/power/shared-device', {
                device_slot: deviceSlot,
                state: state
            });
        };

        /**
         * Powers on/off an entire pod.
         *
         * @param {String} podId
         *     The ID of the pod.
         *
         * @param {Number} state
         *     Power state: 1 = on, 2 = off.
         *
         * @returns {Promise}
         *     A promise that resolves when the power command is executed.
         */
        service.powerPod = function powerPod(podId, state) {
            return flaskApiService.post('/power/pod', {
                pod_id: podId,
                state: state
            });
        };

        return service;
    }
]);
